@if (isAvailable()) {
  <div
    class="flex flex-col gap-y-1 rounded-xl bg-gradient-to-br from-brand-studio-dark to-brand-studio p-5 text-white"
  >
    <p class="m-0 text-xs font-bold tracking-[0.08em] text-white/75 uppercase">
      Estimated audience size
    </p>
    <p class="m-0 text-3xl font-bold tabular-nums">{{ audienceRange() }}</p>
    <p class="m-0 text-sm text-white/80">
      TikTok's estimate for this targeting. Delivery depends on your budget and the auction.
    </p>
  </div>
} @else {
  <div class="flex flex-col gap-y-1 rounded-xl border border-border bg-muted/50 p-5">
    <p class="m-0 text-xs font-bold tracking-[0.08em] text-secondary uppercase">
      Estimated audience size
    </p>
    <p class="m-0 text-lg font-semibold text-primary">Not available</p>
    <p class="m-0 text-sm text-secondary">{{ unavailableReason() }}</p>
  </div>
}
